import { render } from "./ForgetModel.vue?vue&type=template&id=86087ada"
import script from "./ForgetModel.vue?vue&type=script&lang=js"
export * from "./ForgetModel.vue?vue&type=script&lang=js"

import exportComponent from "G:\\VUE\\waimao518_3.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__